import Honeybadger from 'honeybadger-js';
import 'lib/vendor_extensions/.modernizrrc.js';

window.Honeybadger = Honeybadger;



// WEBPACK FOOTER //
// ./app/javascript/packs/head_scripts.js